<template>
  <div id="dash-root" class="therapist">
    <therapist-create-dash-component v-for="(dashpart, index) in dashparts" class="panel panel-flat"
                                     :part="dashpart"
                                     :key="index"
                                     :initial-date="initialDate"
                                     :do_refresh="do_refresh"
                                     :is_admin="is_admin">
    </therapist-create-dash-component>
  </div>
</template>

<script>

import TherapistDashModalShowLocationInfo from "./TherapistDashModalShowLocationInfo";
import TherapistDashModalUnbook from "./TherapistDashModalUnbook";
import TherapistDashModalLock from './TherapistDashModalLock'
import AddAvailabilityModal from "../../Availability/AddAvailabilityModal";
import TherapistDashModalLockMonth from "./TherapistDashModalLockMonth";
import TherapistDashModalAddExpenditure from "./TherapistDashModalAddExpenditure";
import TherapistDashModalAddSchedule from "./TherapistDashModalAddSchedule";
import TherapistDashModalManualBooking from "./TherapistDashModalManualBooking";
import TherapistDashModalRemoveDay from "./TherapistDashModalRemoveDay";
import TherapistDashModalCustomerPresent from "./TherapistDashModalCustomerPresent";
import TherapistDashModalCustomerAbsent from "./TherapistDashModalCustomerAbsent";
import TherapistDashModalDeleteBooking from "./TherapistDashModalDeleteBooking";
import TherapistDashModalDeleteExpenditure from "./TherapistDashModalDeleteExpenditure";
import TherapistDashModalAddAdministrativeTime from "./TherapistDashModalAddAdministrativeTime";
import TherapistDashModalDeleteAdminTime from "./TherapistDashModalDeleteAdminTime";

export default {
  components: {TherapistDashModalUnbook, TherapistDashModalShowLocationInfo, TherapistDashModalLock,
    TherapistDashModalLockMonth, TherapistDashModalAddExpenditure, TherapistDashModalAddSchedule,
    TherapistDashModalManualBooking, TherapistDashModalRemoveDay, TherapistDashModalCustomerPresent,
    TherapistDashModalCustomerAbsent, TherapistDashModalDeleteBooking, TherapistDashModalDeleteExpenditure,
    TherapistDashModalAddAdministrativeTime},
  props: ['therapist_id', 'therapist_name', 'route_refresh',
    'route_lock', 'route_lock_month', 'route_absent', 'route_delete_booking',
    'route_delete_day', 'therapist_self_admin', 'route_add_expenditure',
    'route_delete_expenditure', 'route_manual_booking', 'route_absences',
    'route_unbook', 'initial_date', 'route_add_admin_time', 'route_delete_admin_time', 'is_admin'
  ],
  name: "therapist-dash",
  data() {
    let initialDate = null;

    if (this.initial_date && this.initial_date != "null") {
      initialDate = moment(this.initial_date, "Y-M-D");
    } else {
      initialDate = moment();
    }

    return {
      dashparts: [],
      do_refresh: false,
      initialDate: initialDate,
    };
  },
  methods: {
    doRefresh: function () {
      this.do_refresh = !this.do_refresh;
    },
    lockDay(date) {
      this.$modal.show(TherapistDashModalLock, {
        'date': date,
        'route_lock': this.route_lock,
      }, {
        'width': '100%',
        'height': 'auto',
        'max-width': 800,
        'adaptive': true,
        'clickToClose': true,
      }, {
        'before-close': this.doRefresh
      })
    },
    lockMonth(date) {
      this.$modal.show(TherapistDashModalLockMonth, {
        'date': date,
        'route_lock_month': this.route_lock_month,
      }, {
        'width': '100%',
        'height': 'auto',
        'max-width': 800,
        'adaptive': true,
        'clickToClose': true,
      }, {
        'before-close': this.doRefresh
      })
    },
    addExpenditure(date) {
      this.$modal.show(TherapistDashModalAddExpenditure, {
        'date': date,
        'route_add_expenditure': this.route_add_expenditure,
      }, {
        'width': '100%',
        'height': 'auto',
        'max-width': 800,
        'adaptive': true,
        'clickToClose': true,
      }, {
        'before-close': this.doRefresh
      })
    },
    addSchedule(date, schedule = null) {
      this.$modal.show(TherapistDashModalAddSchedule, {
        'date': date,
        'schedule': schedule,
        'route_delete_day': this.route_add_expenditure,
      }, {
        'width': '100%',
        'height': 'auto',
        'max-width': 800,
        'adaptive': true,
        'clickToClose': true,
      }, {
        'before-close': this.doRefresh
      })
    },
    manualBooking(date) {
      this.$modal.show(TherapistDashModalManualBooking, {
        'date': date,
        'route_delete_day': this.route_add_expenditure,
      }, {
        'width': '100%',
        'height': 'auto',
        'max-width': 800,
        'adaptive': true,
        'clickToClose': true,
      }, {
        'before-close': this.doRefresh
      })
    },
    removeDay(date) {
      this.$modal.show(TherapistDashModalRemoveDay, {
        'date': date,
        'route_delete_day': this.route_delete_day,
        'therapist_self_admin': this.therapist_self_admin,
      }, {
        'width': '100%',
        'height': 'auto',
        'max-width': 800,
        'adaptive': true,
        'clickToClose': true,
      }, {
        'before-close': this.doRefresh
      })
    },
    customerPresent(info) {
      this.$modal.show(TherapistDashModalCustomerPresent, {
        'info': info,
        'route_present': this.route_absent,
      }, {
        'width': '100%',
        'height': 'auto',
        'max-width': 800,
        'adaptive': true,
        'clickToClose': true,
      }, {
        'before-close': this.doRefresh
      })
    },
    customerAbsent(info) {
      this.$modal.show(TherapistDashModalCustomerAbsent, {
        'info': info,
        'route_absent': this.route_absent,
      }, {
        'width': '100%',
        'height': 'auto',
        'max-width': 800,
        'adaptive': true,
        'clickToClose': true,
      }, {
        'before-close': this.doRefresh
      })
    },
    customerUnbook(info) {
      this.$modal.show(TherapistDashModalUnbook, {
        'info': info,
        'route_unbook': this.route_unbook,
      }, {
        'width': '100%',
        'height': 'auto',
        'max-width': 800,
        'adaptive': true,
        'clickToClose': true,
      }, {
        'before-close': this.doRefresh
      })
    },
    deleteBooking(info) {
      this.$modal.show(TherapistDashModalDeleteBooking, {
        'info': info,
        'route_delete_booking': this.route_delete_booking,
      }, {
        'width': '100%',
        'height': 'auto',
        'max-width': 800,
        'adaptive': true,
        'clickToClose': true,
      }, {
        'before-close': this.doRefresh
      })
    },
    deleteExpenditure(info) {
      this.$modal.show(TherapistDashModalDeleteExpenditure, {
        'info': info,
        'route_delete_expenditure': this.route_delete_expenditure,
      }, {
        'width': '100%',
        'height': 'auto',
        'max-width': 800,
        'adaptive': true,
        'clickToClose': true,
      }, {
        'before-close': this.doRefresh
      })
    },
    addAdminTime(date) {
      this.$modal.show(TherapistDashModalAddAdministrativeTime, {
        'date': date,
        'route_add_admin_time': this.route_add_admin_time,
      }, {
        'width': '100%',
        'height': 'auto',
        'max-width': 800,
        'adaptive': true,
        'clickToClose': true,
      }, {
        'before-close': this.doRefresh
      })
    },
    deleteAdminTime(info) {
      this.$modal.show(TherapistDashModalDeleteAdminTime, {
        'info': info,
        'route_delete_admin_time': this.route_delete_admin_time,
      }, {
        'width': '100%',
        'height': 'auto',
        'max-width': 800,
        'adaptive': true,
        'clickToClose': true,
      }, {
        'before-close': this.doRefresh
      })
    }
  },
  mounted() {
    let self = this;
    axios.get(this.$portalUrl(this.route_refresh))
        .then(function (response) {
          self.dashparts = response.data;
        })
        .catch(function (error) {
        })
    this.$eventHub.$on('lock-day', this.lockDay);
    this.$eventHub.$on('lock-month', this.lockMonth);
    this.$eventHub.$on('add-expenditure', this.addExpenditure);
    this.$eventHub.$on('therapist-add-schedule', this.addSchedule);
    this.$eventHub.$on('therapist-manual-booking', this.manualBooking);
    this.$eventHub.$on('therapist-remove-day', this.removeDay);
    this.$eventHub.$on('therapist-customer-present', this.customerPresent);
    this.$eventHub.$on('therapist-customer-absent', this.customerAbsent);
    this.$eventHub.$on('therapist-customer-unbook', this.customerUnbook);
    this.$eventHub.$on('therapist-delete-booking', this.deleteBooking);
    this.$eventHub.$on('therapist-delete-expenditure', this.deleteExpenditure);
    this.$eventHub.$on('therapist-add-admin-time', this.addAdminTime);
    this.$eventHub.$on('therapist-delete-admin-time', this.deleteAdminTime);

  }
}
</script>

<style scoped>

</style>
